var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.flag),expression:"flag"}],staticClass:"shadow",attrs:{"element-loading-text":'正在上传资源中' + _vm.progress + '%',"element-loading-spinner":"el-icon-loading","element-loading-background":"rgba(0, 0, 0, 0.5)"}})
}
var staticRenderFns = []

export { render, staticRenderFns }